'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CloseButton = require('../CloseButton');

var _CloseButton2 = _interopRequireDefault(_CloseButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverCloseButton = function (_PureComponent) {
  _inherits(PopoverCloseButton, _PureComponent);

  function PopoverCloseButton() {
    _classCallCheck(this, PopoverCloseButton);

    return _possibleConstructorReturn(this, (PopoverCloseButton.__proto__ || Object.getPrototypeOf(PopoverCloseButton)).apply(this, arguments));
  }

  _createClass(PopoverCloseButton, [{
    key: 'render',
    value: function render() {
      var onClick = this.props.onClick;

      return _react2.default.createElement(_CloseButton2.default, { className: 'PopoverCloseButton', onClick: onClick });
    }
  }]);

  return PopoverCloseButton;
}(_react.PureComponent);

PopoverCloseButton.propTypes = {
  onClick: _propTypes2.default.func.isRequired
};

exports.default = PopoverCloseButton;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/Popover/PopoverCloseButton.js
// module id = 242
// module chunks = 0